import { BugOutlined, DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import { getCampaignsQuery, getFieldbooksExportFertilizersQuery } from "@graphql/queries";
import { Button, Card, Select, Spin } from "antd";
import { json2excel } from "js2excel";
import uniq from "lodash/uniq";
import moment from "moment";
import React, { useEffect, useState } from "react";

const iconStyle = { fontSize: 48, marginBottom: 40 };
const { Option } = Select;

function Fertilizers() {
  // Fetch available campaigns/years
  const { loading: loadingCampaigns, data: campaignsData } = useQuery(getCampaignsQuery);
  const availableYears = uniq(campaignsData?.campaigns?.map(({ year }) => year)?.sort());

  const [year, setYear] = useState(null);
  const [data, setData] = useState([]);

  // Lazy query for fieldbooks - only runs when year is selected
  const [fetchFieldbooks, { loading: loadingFieldbooks, data: fieldbooksData }] = useLazyQuery(
    getFieldbooksExportFertilizersQuery,
    {
      variables: { year: year ? String(year) : null },
      skip: !year,
    },
  );

  // Trigger fetch when year changes
  useEffect(() => {
    if (year) {
      fetchFieldbooks();
    } else {
      setData([]);
    }
  }, [year, fetchFieldbooks]);

  // Process fieldbooks data when it arrives
  useEffect(() => {
    const fieldbooks = fieldbooksData?.fieldbooks;
    const generated = [];

    if (fieldbooks) {
      // eslint-disable-next-line no-unused-expressions
      fieldbooks?.map((fieldbook) => {
        const producers = fieldbook?.producers;
        const parcel = fieldbook?.parcels[0]?.parcel;

        if (!parcel) return;

        // eslint-disable-next-line no-unused-expressions
        fieldbook.fertilizations?.map((fertilization) => {
          generated.push({
            Organização: "Provape",
            Produtor: producers.map(({ producer }) => producer?.name).join(", "),
            Número: producers.map(({ producer }) => producer?.number).join(", "),
            Parcela: parcel.portion?.name,
            Localização: parcel.portion?.location,
            Área: parcel.area,
            "Data Aplicação": moment(fertilization.date).format("DD-MM-YYYY"),
            Fertilizante: fertilization.fertilizer?.name,
            "N (%)": fertilization.fertilizer?.n,
            "P (%)": fertilization.fertilizer?.p,
            "K (%)": fertilization.fertilizer?.k,
            Dose: fertilization.dose,
            Unidade: fertilization.unity?.name,
            Fornecedor: fertilization.provider?.name,
          });
        });
      });

      setData(generated);
    }
  }, [fieldbooksData]);

  const downloadFile = () => {
    if (data.length > 0) {
      json2excel({
        data,
        name: "Fertilizantes",
      });
    }
  };

  const isLoading = loadingCampaigns || loadingFieldbooks;

  return (
    <Card title="Fertilizantes" style={{ textAlign: "center" }}>
      <div>
        <BugOutlined style={iconStyle} />
      </div>

      {loadingCampaigns ? (
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      ) : (
        <>
          <Select
            placeholder="Selecione um ano"
            optionFilterProp="children"
            onChange={setYear}
            value={year}
            disabled={availableYears.length === 0}
            style={{ marginRight: 10, minWidth: 150 }}
          >
            {availableYears?.map((year) => (
              <Option value={year} key={year}>
                {year}
              </Option>
            ))}
          </Select>

          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={downloadFile}
            disabled={!year || isLoading}
            loading={loadingFieldbooks}
          >
            Exportar {data.length} fertilizantes
          </Button>

          {!year && (
            <div style={{ marginTop: 20, fontSize: 12, color: "#999" }}>Selecione um ano para carregar os dados</div>
          )}
        </>
      )}
    </Card>
  );
}

export default Fertilizers;
